<h2 mat-dialog-title>Update &amp; Sync</h2>
<mat-dialog-content class="mat-typography">
  <p>Confirm and push all staged changes, then sync them to Shopify. Choose how the Shopify sync runs:</p>
  <mat-radio-group class="sync-mode-group" [(ngModel)]="mode">
    <mat-radio-button color="primary" value="bulk">
      <strong>Bulk sync (recommended)</strong>
      <div class="sync-mode-hint">Sends eligible product updates to Shopify as concurrent bulk operations — minutes instead of hours for large runs. Items needing media or collection updates automatically use the standard queue.</div>
    </mat-radio-button>
    <mat-radio-button color="primary" value="queue">
      <strong>Standard queue sync</strong>
      <div class="sync-mode-hint">One API call per product. Slower legacy path — large runs can take hours.</div>
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()">Start Sync</button>
</mat-dialog-actions>
